// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3MvnW","buttons":"styles_buttons__3C10c"};